import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useSyntheseTresorerie, usePrevisionTresorerie } from '../../api/tresorerie.js';
import { useShellContext } from '../shell/context.js';
import { TresorerieCadre, Montant, DateJour, EtatRequete } from './commun.js';
import { TableauPrevision } from './PrevisionPage.js';
import styles from './Tresorerie.module.css';
function Contenu() {
  const { galerieSlug } = useShellContext();
  const { t } = useTranslation('regie');
  const q = useSyntheseTresorerie(galerieSlug);
  const prevision = usePrevisionTresorerie(galerieSlug, '13s');
  const label = (c: string) => t(`tresorerie.${c}`);
  return (
    <>
      <EtatRequete requete={q} />
      {q.data && (
        <>
          <div className={styles.actions}>
            <Link to={`/${galerieSlug}/tresorerie/lignes`}>
              {label('aTraiter')} : {q.data.nonRapprochees}
            </Link>
            <Link to={`/${galerieSlug}/tresorerie/ecarts`}>
              {label('ecarts')} : {q.data.nombreEcarts}
            </Link>
          </div>
          <div className={styles.cartes}>
            {q.data.comptes.map((c) => (
              <section key={c.id} className={styles.carte}>
                <h2>{c.libelle}</h2>
                <p>{c.iban}</p>
                {c.dernierReleveLe && (
                  <p>
                    {label('dateDernierReleve')} <DateJour date={c.dernierReleveLe} />
                  </p>
                )}
                <p>
                  {label('soldeCalcule')} <Montant cents={c.soldeCentimes} /> ·{' '}
                  <DateJour date={c.soldeLe} />
                </p>
                {c.soldeBanque ? (
                  <p>
                    {label('dernierReleve')} <DateJour date={c.soldeBanque.date} /> ·{' '}
                    <Montant cents={c.soldeBanque.montantCentimes} />
                  </p>
                ) : (
                  <p>{label('sansReleve')}</p>
                )}
                {c.ecartSolde !== undefined && (
                  <p role="status">
                    {label('ecartBanque')} <Montant cents={c.ecartSolde} />
                  </p>
                )}
                <p>
                  {label('aTraiter')} : {c.nonRapprochees}
                </p>
              </section>
            ))}
          </div>
        </>
      )}
      <EtatRequete requete={prevision} />
      {prevision.data && <TableauPrevision prevision={prevision.data} court />}
    </>
  );
}
export function TresoreriePage() {
  return (
    <TresorerieCadre titre="titre">
      <Contenu />
    </TresorerieCadre>
  );
}
